import { ChangeDetectionStrategy, Component, OnChanges, OnDestroy, SimpleChanges, inject } from '@angular/core';
import { AspectRatio } from '@knorr-bremse-portals/ngx-components';
import { Section, SectionAttributes } from '../../../app/types/section';
import { SectionComponent } from '../../components/section/section.component';
import { InternalVisualOverlayFigureSection, mediumSectionToHeroItem } from '../header-medium-slider/header-medium-slider.component';
import { ImageOverlayFigureSection } from '../../components/visual-overlayed-figure/visual-overlayed-figure.component';
import { OgImageService, OgImage } from '../../../app/providers/og-image.service';

import { HeroItem, HeroItemComponent, HeroPicture, isHeroPicture } from '@knorr-bremse-portals/ngx-components/components/hero/hero-item';
import { HeroCarouselComponent, provideHeroCarouselIntl } from '@knorr-bremse-portals/ngx-components/components/hero/hero-carousel';
import { imageToPicture } from '../../components/plain-image/plain-image.component';
import { LocalHeroCarouselIntl } from '../../providers/intl/hero-carousel.intl';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type HeaderMediumSection = Section<
  {
    numColumns: 12;
    media: InternalVisualOverlayFigureSection[];
    mediaMobile: InternalVisualOverlayFigureSection[];
  } & SectionAttributes,
  [
    'numColumns',
  ],
  'header-medium'
>;

@Component({
    selector: 'app-header-medium',
    styleUrls: ['./header-medium.component.scss'],
    templateUrl: './header-medium.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        HeroCarouselComponent,
        HeroItemComponent,
        FsButtonComponent,
    ],
    providers: [
        provideHeroCarouselIntl(LocalHeroCarouselIntl),
    ],
})
export class HeaderMediumComponent extends SectionComponent<HeaderMediumSection> implements OnDestroy, OnChanges {

  private ogImageService = inject(OgImageService);
  private ogImages: (OgImage | undefined)[] = [];

  protected pages: HeroItem[] = [];

  public ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges['attributes']) {
      this.pages = this.attributes.media.map((medium, index): HeroItem => {
        const item = mediumSectionToHeroItem(medium, AspectRatio.Wide);
        if (isHeroPicture(item)) {
          const mobileMedium = this.attributes.mediaMobile?.[index] as ImageOverlayFigureSection;
          if (mobileMedium) {
            const mobilePicture = imageToPicture({
              src: mobileMedium.attributes.src,
              srcset: mobileMedium.attributes.srcset,
              alt: mobileMedium.attributes.alt,
              original: mobileMedium.attributes.original,
            }, AspectRatio.Standard);

            item.picture[AspectRatio.Standard] = mobilePicture.sources[AspectRatio.Standard];
          }
        }
        return item;
      });

      this.clearOgImages();
      this.pages.filter((item): item is HeroPicture => item.type === 'picture').forEach((item) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.ogImages.push(this.ogImageService.add(item.picture.original!['?'], item.alt));
      });
    }
  }

  public ngOnDestroy(): void {
    this.clearOgImages();
  }

  private clearOgImages(): void {
    this.ogImages
      .filter((result): result is OgImage => result !== undefined)
      .forEach((result) =>  this.ogImageService.remove(result));
  }

}
